module.exports = "/_next/static/images/top-arrow-med-688c3173a7b30757fe5a6d7fc706ae90.svg";